import React from 'react';
import { View, Pressable, ViewStyle, TextStyle } from 'react-native';
import {ToolbarProps, Views} from 'react-big-calendar';
import { EventType } from '../../../../api/DemandeAbsence/types';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { stdCouleurBleu } from '@commonStyle';
import { TooltipWrapper } from '../../../TooltipWrapper';
import styles from '../../CalendrierUniversel.styles';

type Props = {
  buttonStyle: ViewStyle,
  buttonSize: number,
  textStyle?: TextStyle
}

export default function FragmentToolbarView(props: ToolbarProps<EventType> & Props){
  const {view, buttonStyle, buttonSize, onView} = props;
  const width = `${100/4}%`;
  return (
    <View style={[styles.buttonList, styles.flexDouble]}>
      <Pressable
        onPress={()=> {onView(Views.DAY)}}
        testID='BT_DAY'
        style={{width}}
      >
        <TooltipWrapper style={{...buttonStyle, backgroundColor: view === Views.DAY ? stdCouleurBleu : buttonStyle.backgroundColor}} tooltip="Jour">
          <Icon name="calendar-today" color={view === Views.DAY ? 'white' : stdCouleurBleu} size={buttonSize} />
        </TooltipWrapper>
      </Pressable>
      <Pressable
        onPress={()=> {onView(Views.WEEK)}}
        testID='BT_WEEK'
        style={{width}}
      >
        <TooltipWrapper style={{...buttonStyle, backgroundColor: view === Views.WEEK ? stdCouleurBleu : buttonStyle.backgroundColor}} tooltip="Semaine">
          <Icon name="calendar-week" color={view === Views.WEEK ? 'white' : stdCouleurBleu} size={buttonSize} />
        </TooltipWrapper>
      </Pressable>
      <Pressable
        onPress={()=> {onView(Views.MONTH)}}
        testID='BT_MONTH'
        style={{width}}
      >
        <TooltipWrapper style={{...buttonStyle, backgroundColor: view === Views.MONTH ? stdCouleurBleu : buttonStyle.backgroundColor}} tooltip="Mois">
          <Icon name="calendar-month" color={view === Views.MONTH ? 'white' : stdCouleurBleu} size={buttonSize} />
        </TooltipWrapper>
      </Pressable>
      <Pressable
        style={{width}}
        onPress={()=> {onView(Views.AGENDA)}}
        testID='BT_AGENDA'
      >
        <TooltipWrapper style={{...buttonStyle, backgroundColor: view === Views.AGENDA ? stdCouleurBleu : buttonStyle.backgroundColor}} tooltip="Agenda">
          <Icon name="format-list-bulleted" color={view === Views.AGENDA ? 'white' : stdCouleurBleu} size={buttonSize} />
        </TooltipWrapper>
      </Pressable>
    </View>
  )
}
